const BUCKET_BASE_URL = process.env.BUCKET_BASE_URL || "assets";

export function Logo() {
  return (
    <a href="#top">
      <img
        alt="east."
        className="w-[251px] h-[109px]"
        src={`${BUCKET_BASE_URL}/images/logo.gif`}
      />
    </a>
  );
}
